import * as Yup from 'yup';
import { emailRegExp, phoneRegExp } from '../../constants/validation_expressions';
import { is_email_unique, is_metaMask_address_unique } from '../../services/account';
import debounce from 'lodash.debounce';
import Web3 from 'web3';

function addStandardUserValidation() {
  const schema = Yup.object().shape(
    {
      firstName: Yup.string().required('First  Name is required'),
      lastName: Yup.string().required('Last Name is required'),
      email: Yup.string().when('meta_mask_address', {
        is: (meta_mask_address) => !meta_mask_address,
        then: Yup.string()
          .required('Email is required')
          .matches(emailRegExp, 'Email is not valid')
          .test('unique_email', 'Email address must be unique', async (emailAddress) => {
            if (emailAddress) {
              const response = await debouncedApiEmailAddress(emailAddress);
              if (!response) return true;
              return response?.data?.data?.unique;
            }
          }),
        otherwise: Yup.string().email('Email is not valid').optional().nullable(),
      }),
      meta_mask_address: Yup.string().when('email', {
        is: (emailAddress) => !emailAddress,
        then: Yup.string()
          .required('Public Address is required')
          .test('test-w3address', 'The Public address is not valid', (value) =>
            Web3.utils.isAddress((value || '').toLowerCase())
          )
          .test('unique_name', 'Public address must be unique', async (address) => {
            if (address) {
              const response = await debouncedApiAddress(address?.trim());
              if (!response) return true;
              return response.data?.data?.unique;
            }
          }),
        otherwise: Yup.string()
          .optional()
          .test('test-w3address', 'The Public address is not valid', (value) => {
            if (value === undefined) {
              return true;
            } else {
              return Web3.utils.isAddress((value || '').toLowerCase());
            }
          })
          .test('unique_name', 'Public address must be unique', async (address) => {
            if (address) {
              const response = await debouncedApiAddress(address?.trim());
              if (!response) return true;
              return response.data?.data?.unique;
            } else {
              return true;
            }
          }),
      }),
      contactNumber: Yup.string()
        .required('Contact is required')
        .matches(phoneRegExp, 'Contact Number is not valid'),
    },
    [['email', 'meta_mask_address']]
  );
  return schema;
}

const debouncedApiEmailAddress = debounce(is_email_unique, 500);

const debouncedApiAddress = debounce(is_metaMask_address_unique, 500);

export { addStandardUserValidation };
